import type { TFunction } from 'i18next';

/** Código estable del backend → clave i18n bajo el namespace `recognition`. */
const ERROR_CODE_KEYS: Record<string, string> = {
  'receptor-required': 'bulk.errors.receptorRequired',
  'receptor-not-found': 'bulk.errors.receptorNotFound',
  'fundamental-invalid': 'bulk.errors.fundamentalInvalid',
  'self-recognition': 'bulk.errors.selfRecognition',
  'blocked-word': 'bulk.errors.blockedWord',
  'weekly-cap-exceeded': 'bulk.errors.weeklyCapExceeded',
  'duplicate-in-file': 'bulk.errors.duplicateInFile',
  'campaign-closed': 'bulk.errors.campaignClosed',
  'not-allowed-for-campaign': 'bulk.errors.notAllowedForCampaign',
  'behavior-invalid': 'bulk.errors.behaviorInvalid',
  'habit-invalid': 'bulk.errors.habitInvalid',
  'multiple-people-not-supported': 'bulk.errors.multiplePeopleNotSupported',
  'max-fundamentals-exceeded': 'bulk.errors.maxFundamentalsExceeded',
};

/**
 * Códigos que el backend reutiliza para más de una causa distinta (ver
 * BulkImportRecognitionsCommandHandler.cs): el texto genérico mapeado podría señalar la celda
 * equivocada, así que para estos se prefiere el mensaje real del backend, específico de la fila.
 */
const AMBIGUOUS_CODES = new Set(['receptor-not-found', 'fundamental-invalid', 'not-allowed-for-campaign']);

/**
 * Traduce el código de error de una fila a texto localizado. Si el código no está en el mapa
 * (backend agregó uno nuevo que el front todavía no conoce), se usa el `message` que el propio
 * backend ya manda en español — nunca se inventa un texto genérico si hay uno real disponible.
 */
export function translateRowError(
  t: TFunction,
  code: string | null,
  fallbackMessage: string | null,
): string {
  if (!code) return fallbackMessage ?? '';
  if (AMBIGUOUS_CODES.has(code) && fallbackMessage) return fallbackMessage;
  const key = ERROR_CODE_KEYS[code];
  if (key) return t(key, { ns: 'recognition' });
  return fallbackMessage ?? t('bulk.errors.generic', { ns: 'recognition' });
}
